<template>
  <v-dialog
    v-model="dialog"
    max-width="700px"
    content-class="notification-setting-dialog"
  >
    <v-card class="notification-setting-card">
      <v-card-title class="modal-title">
        <h2 class="title">Notification Settings</h2>
        <button icon @click="close" class="btn-close" aria-label="Close modal">
          <span aria-hidden="true">&times;</span>
        </button>
      </v-card-title>

      <v-card-text class="modal-content-container">
        <p>
          By default we subscribe you to the following announcement and activity
          email notifications. You can change your notification settings at any
          time within the email itself - just scroll to the bottom of an email
          notification. Changing email notifications within Eddy is not
          supported at the moment, and will be added as a feature at a later
          date.
          <br />
          <b>
            <ul>
              <li>
                Latest Resources on Eddy: Fresh resources and upcoming events.
              </li>
              <li>
                Feedback: Help us continue improving our product and lesson
                packages!
              </li>
            </ul>
          </b>
          <br /><br />
          No spam ever. Unsubscribe any time.
        </p>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { ref, watch } from "vue";

export default {
  props: {
    isOpen: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const dialog = ref(false);

    watch(
      () => props.isOpen,
      (newVal) => {
        dialog.value = newVal;
      }
    );

    watch(dialog, (newVal) => {
      if (!newVal) {
        close();
      }
    });

    const close = () => {
      emit("close");
    };

    return {
      dialog,
      close,
    };
  },
};
</script>

<style scoped>
.notification-setting-dialog {
  border-radius: 20px;
}

.notification-setting-card {
  border-radius: 20px;
  overflow: hidden;
  height: auto !important;
  max-height: 85vh;
}

.modal-title {
  background-color: #00925e;
  padding: 14px 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: white;
}

.title {
  font-size: 40px;
  color: white;
  margin-bottom: 0;
}

.btn-close {
  font-size: 2rem;
  color: #fff;
}

.modal-content-container {
  padding: 20px 30px;
  max-height: 70vh;
  overflow-y: auto;
}

.modal-content-container::-webkit-scrollbar {
  width: 8px;
}

.modal-content-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.modal-content-container::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

.modal-content-container::-webkit-scrollbar-thumb:hover {
  background: #555;
}

ul {
  margin-left: 1rem;
  padding-left: 1rem;
}

ul li {
  margin: 0;
  margin-bottom: 8px;
}
</style>
